import PlaceTokens from "@/utils/constants/PlaceTokens.ts";
import {CustomPlaceTokens} from "@/router/RouteNames.ts";
import NamaCommon from "@/utils/common/NamaCommon.ts";
import ObjectChecker from "@/utils/common/ObjectChecker.ts";
import {LocationQueryRaw} from "vue-router";
import router from "@/router";

export default abstract class NamaPlace {
  public query: Record<string, string | undefined> = {};

  constructor(query?: LocationQueryRaw) {
    this.query = NamaCommon.cloneObject(query || {});
  }

  setParameters(query: Record<string, string | undefined>) {
    this.query = NamaCommon.cloneObject(query || {});
  }

  get src(): string | undefined {
    return this.query[PlaceTokens.PRM_MENU_HASH];
  }

  set src(value: string | undefined) {
    if (ObjectChecker.isEmptyOrNull(value))
      return;
    this.query[PlaceTokens.PRM_MENU_HASH] = value;
  }

  get forceRefreshKey(): string | undefined {
    return this.query[CustomPlaceTokens.FORCE_REFRESH_KEY];
  }

  set forceRefreshKey(value: string | undefined) {
    this.query[CustomPlaceTokens.FORCE_REFRESH_KEY] = value;
  }

  fetchQuery(): Record<string, string | undefined> {
    return this.query;
  }

  getTitleForWindow(): string {
    return 'homePage'
  }

  toLink(): string {
    return router.resolve({query: this.query, name: this.getRouteName()}).href
  }

  getRouteName(): string | null {
    return null;
  }
}
